module.exports = __webpack_public_path__ + "static/media/appstorebadge_zh.4641acc3.svg";